import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = ({ className = '' }) => {
  const securityFeatures = [
    {
      icon: 'Shield',
      label: 'SSL Encrypted',
      description: 'Your data is protected with 256-bit encryption',
    },
    {
      icon: 'Lock',
      label: 'Privacy First',
      description: 'No tracking, no ads, your learning stays private',
    },
    {
      icon: 'Database',
      label: 'Local Storage',
      description: 'Optional offline mode with local data processing',
    },
  ];

  return (
    <div className={`space-y-4 ${className}`}>
      <div className="text-center">
        <h3 className="text-sm font-medium text-foreground mb-2">Your Privacy Matters</h3>
        <p className="text-xs text-muted-foreground">
          Cogito is built with privacy-first principles and data ownership in mind.
        </p>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {securityFeatures?.map((feature, index) => (
          <div
            key={index}
            className="flex items-center space-x-3 p-3 bg-muted/30 rounded-lg border border-border/50"
          >
            <div className="w-8 h-8 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={feature?.icon} size={16} color="var(--color-success)" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground">{feature?.label}</p>
              <p className="text-xs text-muted-foreground leading-relaxed">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-center space-x-4 pt-2">
        <div className="flex items-center space-x-1">
          <Icon name="CheckCircle" size={14} color="var(--color-success)" />
          <span className="text-xs text-muted-foreground">Open Source</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="Globe" size={14} color="var(--color-accent)" />
          <span className="text-xs text-muted-foreground">GDPR Compliant</span>
        </div>
      </div>
    </div>
  );
};

export default SecurityBadges;